import { registerTheme } from "echarts";
import { MessageToast } from "../components/toast";
import { closeSettingsModal } from "../settings";
import { initSteps } from "./steps";
import { galleryCsvSteps } from "./steps/csvTour";
import { driverObj, prepareSteps } from "./utils";

const TOUR_KEY = "completeTour";

// Папка и сектор, которые пользователь создает во время гайда
export const tourData: {
    folderId: string | null,
    sectorId: string | null
} = {folderId: null, sectorId: null};


export const startTour = () => {
    setStartTour();

    const steps = initSteps();
    const preparedSteps = prepareSteps(steps);
    
    driverObj.setSteps(preparedSteps);
    
    // Запуск тура
    driverObj.drive();
}


/**
 * Тур (инструкция) по работе с csv графиками
*/
export const startCsvTour = () => {
    
    if(!document.querySelector('.folder-wrapper')){
        MessageToast.showDanger('1', 'Для прохождения инструкции требуется рассчитать график');
        return;
    };
    
    const preparedSteps = prepareSteps(galleryCsvSteps);
    driverObj.setSteps(preparedSteps);
    driverObj.drive();
}

// Запуск тура по csv графикам
const startCsvTourBtn = document.getElementById('start-csv-tour-btn') as HTMLButtonElement;
if (startCsvTourBtn){
    startCsvTourBtn.addEventListener('click', startCsvTour);
}

/**
 * Проверка, что тур завершен, иначе начинаем его
*/
export const checkAndStartTour = () => {
    if (localStorage.getItem(TOUR_KEY) === "true") return;
    startTour();
}

export const isTourComplete = (): boolean => {
    return localStorage.getItem(TOUR_KEY) === "true";
}

export const completeTour = () => {
    localStorage.setItem(TOUR_KEY, "true");
}

export const setStartTour = () => {
    localStorage.setItem(TOUR_KEY, "false");
}

/**
 * Инициализация кнопки "Инструкция" в настройках
 */
export const initConstControl = () => {
    const startTourBtn = document.getElementById('start-tour-btn')

    if (!(startTourBtn instanceof HTMLButtonElement)) {
        throw new Error("Ошибка! Кнопка 'Инструкция' не найдена");
    }

    startTourBtn.addEventListener('click', () => {
        closeSettingsModal();
        startTour();
    })
}